export default __webpack_public_path__ + "static/media/AWS_logo_RGB_light_mode.cc38dbe9.svg";